import Icon from "@mui/material/Icon";
import Logout from "@mui/icons-material/Logout";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import Blog from "@mui/icons-material/Newspaper";
import PersonSearch from "@mui/icons-material/PersonSearch";
import LogOut from "./pages/LandingPages/LogOut/LogOut";

const routes = [
  {
    name: "Home",
    icon: <Icon>home</Icon>,
    route: "/app/trainingcompanydashboard",
  },
  {
    name: "Create Profile",
    icon: <AccountBoxIcon />,
    route: "/app/trainingcompanyprofile",
  },
  {
    name: "Create Training",
    icon: <Blog />,
    route: "/app/trainingpost",
  },
  {
    name: "Trainers",
    icon: <PersonSearch />,
    route: "/app/trainerlistindex",
  },
  {
    name: "LogOut",
    route: "/app/logout",
    component: <LogOut />,
    icon: <Logout />,
  },
];

export default routes;
